import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6355567a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-area" }
const _hoisted_2 = { class: "search-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-result" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "area-searchResult"
}
const _hoisted_5 = { class: "the-search-result-main-total" }
const _hoisted_6 = { class: "has-text-title has-text-contents-title" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 一覧をダウンロード ")
const _hoisted_8 = { class: "content has-background-contents shadow" }
const _hoisted_9 = { class: "the-search-result-main-nav is-hidden-mobile level-right has-background-contents" }
const _hoisted_10 = { class: "nowrap" }
const _hoisted_11 = ["onClick", "onKeydown"]
const _hoisted_12 = { class: "nowrap" }
const _hoisted_13 = { class: "nowrap" }
const _hoisted_14 = { class: "nowrap" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 情報提供 ")
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-result" }, "一致する著作者は見つかりませんでした。", -1))
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_KeywordSearch = _resolveComponent("KeywordSearch")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_Table = _resolveComponent("Table")!
  const _component_PageNavigation = _resolveComponent("PageNavigation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_KeywordSearch, {
          modelValue: _ctx.keyword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
          onSearch: _ctx.pushState,
          placeholder: "著者名, 著者別名",
          class: "author-keyword",
          label: "著者名, 著者別名"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AppButton, {
              styled: "is-none",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DssIcon, {
                  icon: "magnifyingglass",
                  label: _ctx.$t('message.doSearch')
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onSearch"]),
        _createVNode(_component_AppSelect, {
          modelValue: _ctx.selected,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event)),
          options: _ctx.selectList,
          class: "select-ndc"
        }, null, 8, ["modelValue", "options"])
      ]),
      _hoisted_3
    ]),
    (_ctx.result.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.pageTotalCount) + " 件中 " + _toDisplayString((_ctx.route.query.size ? Number(_ctx.route.query.size) : 20) * _ctx.pageNumber + 1) + "-" + _toDisplayString((_ctx.route.query.size ? Number(_ctx.route.query.size) : 20) * (_ctx.pageNumber + 1) < _ctx.pageTotalCount ? (_ctx.route.query.size ? Number(_ctx.route.query.size) : 20) * (_ctx.pageNumber + 1) : _ctx.pageTotalCount) + " 件を表示 ", 1),
            _createVNode(_component_AppButton, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.download())),
              onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.download()), ["prevent"]), ["space","enter"])),
              buttonId: 'button-download'
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("nav", _hoisted_9, [
              _createVNode(_component_AppSelect, {
                modelValue: _ctx.numSelected,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.numSelected) = $event)),
                options: _ctx.displayLocale,
                class: "select-pageNum"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_AppSelect, {
                modelValue: _ctx.sortSelected,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sortSelected) = $event)),
                options: _ctx.sortList,
                class: "select-sort"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Table, {
                header: _ctx.header,
                className: 'contents'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result, (data, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString((_ctx.route.query.size ? Number(_ctx.route.query.size) : 20) * _ctx.pageNumber + index + 1), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(data._source.authorId), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.detail(data._source.authorId)),
                            onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.detail(data._source.authorId)), ["prevent"]), ["space","enter"]),
                            class: _normalizeClass(`button-author-${ (_ctx.route.query.size ? Number(_ctx.route.query.size) : 20) * _ctx.pageNumber + index + 1 }`),
                            style: {"text-align":"left"}
                          }, [
                            _createElementVNode("a", null, _toDisplayString(data._source.authorName), 1)
                          ], 42, _hoisted_11)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(data._source.authorAliasName), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(data._source.birthYear ? `${data._source.birthYear}年` : ''), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(data._source.deathYear ? `${data._source.deathYear}年` : ''), 1),
                        _createElementVNode("td", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data._source.ndc ? _ctx.convertNdc(data._source.ndc) : [''], (ndcData, index) => {
                            return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(ndcData), 1))
                          }), 128))
                        ]),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(data._source.worksNum ? data._source.worksNum : 0) + "件", 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_AppButton, {
                            onClick: ($event: any) => (_ctx.toAuthorInput(data._source.authorId)),
                            onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.toAuthorInput(data._source.authorId)), ["prevent"]), ["space","enter"]),
                            buttonId: `button-toAuthorInput-${index + 1}`
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 2
                          }, 1032, ["onClick", "onKeydown", "buttonId"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["header"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_PageNavigation, {
              modelValue: _ctx.pageNumber,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageNumber) = $event)),
              displayCount: 5,
              items: _ctx.pageNavigationIndex
            }, null, 8, ["modelValue", "items"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
  ], 64))
}